module.exports = __webpack_public_path__ + "static/media/Sew.281cfa72.png";